"use client";

import { useEffect } from "react";
import Script from "next/script";
import { usePathname } from "next/navigation";
import { thirdPartyScriptCrossOriginProp } from "@/lib/analytics/third-party-scripts";

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void;
  }
}

const META_PIXEL_ID = process.env.NEXT_PUBLIC_META_PIXEL_ID;

export default function MetaPixel() {
  const pathname = usePathname();
  const shouldLoadMetaPixel =
    process.env.NODE_ENV === "production" && Boolean(META_PIXEL_ID);

  useEffect(() => {
    if (!shouldLoadMetaPixel) return;
    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [pathname, shouldLoadMetaPixel]);

  // Avoid loading third-party tracking in local/dev environments.
  if (!shouldLoadMetaPixel) {
    return null;
  }

  return (
    <>
      <Script
        id="meta-pixel"
        strategy="afterInteractive"
        crossOrigin={thirdPartyScriptCrossOriginProp("meta-pixel")}
      >
        {`
 !function(f,b,e,v,n,t,s)
 {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
 n.callMethod.apply(n,arguments):n.queue.push(arguments)};
 if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
 n.queue=[];t=b.createElement(e);t.async=!0;
 t.src=v;s=b.getElementsByTagName(e)[0];
 s.parentNode.insertBefore(t,s)}(window, document,'script',
 'https://connect.facebook.net/en_US/fbevents.js');
 fbq('init', '${META_PIXEL_ID}');
 fbq('track', 'PageView');
 `}
      </Script>
    </>
  );
}
